import styled from "styled-components";

export const Message = styled.p`

    @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;1,300&display=swap');
    font-family: 'Lato', sans-serif;

    color:#C3CBF4;
    font-size: larger;

    

`